module.exports = __webpack_public_path__ + "img/study_banner.d25a4312.png";